import axios from "axios";
import { API_END_POINTS } from "../../API_END_POINTS";

const STTIPE_URL = `${process.env.REACT_APP_API_URL}${API_END_POINTS.stripePayment}`;

export const fetchStripeToken = async (cardDetails) => {
  const response = await axios.post(
    "https://api.stripe.com/v1/tokens",
    {
      card: {
        number: cardDetails.cardNumber.replace(/\s/g, ""),
        exp_month: cardDetails.expiryDate.split("/")[0],
        exp_year: `20${cardDetails.expiryDate.split("/")[1]}`,
        cvc: cardDetails.csv,
      },
    },
    {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer pk_test_51MPqPfHqnkArTcpOGeXcM6rFXPr0kWWyvZdGRyRH2xN9soeZGfhA7nLEDxd6xdjRuuxIuTyoAkdqg1WgzlLHkg5L00XfU5njRy`,
      },
    }
  );
  return response;
};

export const StripeCharge = async (order_ids, token) => {
  try {
    const formattedOrderIds = Array.isArray(order_ids)
      ? order_ids
      : order_ids.split(",");

    const response = await axios.post(
      STTIPE_URL,
      {
        order_ids: formattedOrderIds,
        token: token,
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          "Content-Type": "application/json",
        },
      }
    );

    return response.data; // Ensure correct data extraction
  } catch (error) {
    throw new Error(
      error.response?.data?.message ||
        "An error occurred while fetching product reviews."
    );
  }
};
